import { Col, Row, Typography } from "antd";

export default function AppFooter() {
    return (
        <Row
            style={{
                height: "100%",
                display: "flex",
                alignContent: "center",
            }}>
            <Col span={8} style={{ textAlign: "center" }}>
                <Typography.Text>Appbox Copyright @2024</Typography.Text>
            </Col>
            <Col span={8} style={{ textAlign: "center" }}>
                <Typography.Text>Need help? <a href="mailto:support@appbox.cloud">support@appbox.cloud</a></Typography.Text>
            </Col>
        </Row>
    );
}
